import React from 'react'
import styled from 'styled-components'
import { MdWeb, MdContacts } from 'react-icons/md'
import { FaCode } from 'react-icons/fa'
// import SocialLinks from '../constants/socialLinks'
import { graphql, useStaticQuery } from 'gatsby'
import Image from 'gatsby-image'
import tutorial from '../assets/tutorial-hell.svg'
import resume from '../assets/resume.svg'
import recruiter from '../assets/recruiter.svg'
import { motion } from 'framer-motion'

const LandingPage = () => {
  function activateAccordian(e) {
    e.preventDefault()
    // this.classList.toggle('active')
  }
  return (
    <LandingPageWrapper animate={{ scale: 1 }}>
      <div className="sales-pitch">
        <motion.img
          initial={{ scale: 1 }}
          animate={{ rotate: 0, scale: 1 }}
          transition={{
            type: 'spring',
            stiffness: 260,
            damping: 20,
          }}
          src={tutorial}
        />
        <div className="sales-pitch-text">
          <motion.h2
            className="tutorial-header"
            // animate={{ color: '#ff2994', scale: 1.1 }}
          >
            Are you stuck in tutorial hell?
          </motion.h2>
          <div>
            Tutorial hell is when you finish a tutorial -> Try to start
            something on your own and get stuck -> Finish a new tutorial -> Try
            to start something on your own and get stuck -> Repeat
          </div>
        </div>
      </div>

      <div className="sales-pitch">
        <div className="sales-pitch-text">
          <motion.h2
            className="tutorial-header"
            // animate={{ color: '#ff2994', scale: 1.1 }}
          >
            Trying to land your first job?
          </motion.h2>
          <div>
            Grab recruiters attention by demonstrating real life experience.
            Demonstrate your abilities by building something real.
          </div>
        </div>
        <motion.img
          initial={{ scale: 1 }}
          animate={{ rotate: 0, scale: 1 }}
          transition={{
            type: 'spring',
            stiffness: 260,
            damping: 20,
          }}
          src={resume}
        />
      </div>

      <div className="sales-pitch">
        <motion.img
          initial={{ scale: 1 }}
          animate={{ rotate: 0, scale: 1 }}
          transition={{
            type: 'spring',
            stiffness: 260,
            damping: 20,
          }}
          src={recruiter}
        />
        <div className="sales-pitch-text">
          <motion.h2
            className="tutorial-header"
            // animate={{ color: '#ff2994', scale: 1.1 }}
          >
            Learn with others.
          </motion.h2>
          <div>
            When you are part of a community that is all working on the same
            problem it allows you to see the many difference approaches that
            others take to get the job done.
          </div>
        </div>
      </div>

      <div className="inside-look">
        <div className="card">
          <FaCode className="icons" />
          <div className="card-title">
            Step 1: Choose a design at your skill level
          </div>
          <p>
            Take a look at the projects to see which one looks like a fit for
            you. Look at the expected outcomes and technology needed.
          </p>
          <img src="" />
        </div>
        <div className="card">
          <MdWeb className="icons" />
          <div className="card-title">
            Step 2: Download starter package (free)
          </div>
          <p>
            The starter package will have mobile and desktop designs along with
            a style guide to get you started.
          </p>
          <img src="" />
        </div>
        <div className="card">
          <MdContacts className="icons" />
          <div className="card-title">
            Step 3: Submit your work for others to learn from!
          </div>
          <p>
            Show off your work to others! This also gives others who might get
            stuck an opportunity to see how you solved a challenge.
          </p>
          <img src="" />
        </div>
      </div>
    </LandingPageWrapper>
  )
}

const LandingPageWrapper = styled(motion.div)`
  display: grid;
  .tutorial-header {
    /* margin-left: 35px; */
  }
  width: 100%;
  /* padding: 0 50px; */
  /* max-width: 1000px; */

  place-items: center;
  .inside-look {
    margin-top: 50px;
    display: grid;
    /* grid-template-columns: 1fr 1fr 1fr; */
    grid-gap: 25px;
    margin-bottom: 50px;
    /* padding: 0 15px; */
  }

  .card {
    /* width: 300px; */
    /* border: 1px solid black; */
    /* border-radius: 10px; */
    padding: 0 24px;
    padding-top: 12px;
    /* box-shadow: 3px 3px 5px 6px #ccc; */
    background: #e5e2fd;
  }

  .card:nth-child(even) {
    background: #fff;
  }

  .card-title {
    font-size: 24px;
    padding-bottom: 12px;
  }

  .icons {
    font-size: 36px;
    color: #ec615b;
  }

  .icons:nth-of-type(even) {
    color: #553cd1;
  }

  .sales-pitch:first-of-type {
    /* margin-top: 150px; */
    padding: 0 0;
    img {
      margin-top: 0;
    }
  }

  .sales-pitch {
    padding: 50px 0;
    margin-bottom: 0;
    display: grid;
    place-items: center;
    /* background: #e5e2fd; */
    img {
      width: 50%;
      margin-bottom: 35px;
      margin-top: 35px;
    }
    /* padding: 0 100px; */
  }

  .sales-pitch:nth-of-type(3) {
    padding: 0;
  }

  .sales-pitch:nth-of-type(2) {
    background: #e5e2fd;
    display: flex;
    flex-direction: column-reverse;
  }

  .sales-pitch-text {
    padding: 15px 15px;
  }

  @media (min-width: 768px) {
    display: grid;

    width: 100%;
    /* padding: 0 50px; */
    /* max-width: 1000px; */

    place-items: center;
    .inside-look {
      margin-top: 50px;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 25px;
      /* margin-bottom: 50px; */
      background: #e5e2fd;
    }
    .card {
      /* width: 300px; */
      /* border: 1px solid black; */
      border-radius: 10px;
      padding: 24px;
      /* box-shadow: 1.5px 1.5px 2.5px 3px #ccc; */
      background: #e5e2fd;
      /* display: inline; */
    }
    .card:nth-child(even) {
      background: #e5e2fd;
    }
    .card-title {
      font-size: 24px;
      padding-bottom: 12px;
    }
  }

  @media (min-width: 900px) {
    display: grid;
    .sales-pitch:nth-of-type(2) {
      display: flex;
      flex-direction: row;
    }
    width: 100%;
    /* padding: 0 50px; */
    /* max-width: 1000px; */

    place-items: center;
    .inside-look {
      /* margin-top: 50px; */
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-gap: 25px;
      /* margin-bottom: 50px; */
      background: #e5e2fd;
    }
    .card {
      /* width: 300px; */
      /* border: 1px solid black; */
      border-radius: 10px;
      padding: 24px;
      /* box-shadow: 1px 1px 1.25px 1.5px #ccc; */
      /* display: inline; */
    }
    .card:nth-of-type(1) {
      margin-left: 50px;
    }
    .card:nth-of-type(3) {
      margin-right: 50px;
    }

    .card:nth-child(even) {
      background: #e5e2fd;
    }
    .card-title {
      font-size: 24px;
      padding-bottom: 12px;
    }

    .sales-pitch {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0px;
      padding: 0;
      /* background: #e5e2fd; */
      img {
        width: 30%;
        padding: 0 25px;
      }
      padding: 0 100px;
    }

    .sales-pitch:nth-of-type(1) {
      img {
        /* width: 25%; */
        margin-left: 100px;
      }
    }
    .sales-pitch:nth-of-type(3) {
      img {
        width: 20%;
        margin-left: 50px;
      }
    }

    .sales-pitch:nth-of-type(2) {
      background: #e5e2fd;
    }
    .sales-pitch-text:nth-of-type(odd) {
      margin-right: 50px;
    }
  }
`

export default LandingPage
